var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"width":"100%","display":"flex","justify-content":"center","margin":"20px"}},[_c('ViewProduct',{attrs:{"product":_vm.product}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }